export default "__VITE_ASSET__BZnpzsk5__"